import { computed, onBeforeMount } from 'vue';
import { useStepData } from '../useStepData';

export type StepPageView = 'loading' | 'theory' | 'drill' | 'error';

/**
 * Standalone StepPage: picks the view only once the step kind is known, so a
 * theory step never sets up StepView first. The step load is started here;
 * StepView/StepTheoryView then find it loaded (shared load state, no 2nd GET).
 */
export function useStepPageView(stepDocId: string) {
  const { stepType, isLoading, loadError, validationErrors, getStep } =
    useStepData(stepDocId);

  onBeforeMount(() => {
    if (!stepType.value) void getStep();
  });

  const view = computed<StepPageView>(() => {
    if (stepType.value === 'theory') return 'theory';
    if (stepType.value) return 'drill';
    if (isLoading.value) return 'loading';
    return loadError.value || validationErrors.value.length
      ? 'error'
      : 'loading';
  });

  function retry() {
    void getStep();
  }

  return { view, loadError, validationErrors, retry };
}
